import React, { Component } from 'react';
import Quote from './quote';
import QuoteNew from './quotesNew';
class Page extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                {/* <Quote></Quote> */}
                <QuoteNew></QuoteNew>
            </div>
        );
    }
}
export default Page;